import { AppTheme } from "@cetma/skeleton-app/index";
import { createTheme } from "@mui/material";


let theme: AppTheme = createTheme();

export default theme;